import Select from '@blocks/Select'
import { desktop, tablet } from '@styles/mixins'
import React from 'react'
import { ValueType } from 'react-select'
import styled, { css } from 'styled-components'

export default function Filters({ sections, archive }: Props) {
    const filters = {
        section: archive.filter<number>("sections", filterBySection),
        status: archive.filter<"voted" | "not_voted">("status", filterByStatus),
        payment: archive.filter<"paid" | "not_paid">("payment", filterByPayment)
    }

    return (
        <>
            <Select
                id="status"
                name="status"
                label="Status"
                background="#fff"
                height="s"
                isClearable
                options={[
                    { label: `Voted`, value: "voted" },
                    { label: `Not Voted`, value: "not_voted" },
                ]}
                onChange={
                    (option: ValueType<{ label: string, value: "voted" | "not_voted" }, false>) =>
                        option?.value ? filters.status.set(option.value) : filters.status.reset()
                }
            />
            <Select
                id="payment"
                name="payment"
                label="Payment"
                background="#fff"
                height="s"
                isClearable
                options={[
                    { label: `Paid`, value: "paid" },
                    { label: `Not Paid`, value: "not_paid" },
                ]}
                onChange={
                    (option: ValueType<{ label: string, value: "paid" | "not_paid" }, false>) =>
                        option?.value ? filters.payment.set(option.value) : filters.payment.reset()
                }
            />
            <Select
                id="sections"
                name="sections"
                label="Sections"
                background="#fff"
                height="s"
                isClearable
                options={
                    sections.map(section => {
                        return {
                            label: `${section.name}`,
                            value: section.id.toString()
                        }
                    })
                }
                onChange={
                    (option: ValueType<{ label: string, value: string }, false>) =>
                        option?.value ? filters.section.set(parseInt(option!.value)) : filters.section.reset()
                }
            />
        </>
    )
}

// FUNCTIONS
const filterBySection: ArchiveHookFilterRule<Admin.Resources.Participation, number>["fn"] = (data, value) => {
    return data?.filter(participation => participation.section.id === value)
}

const filterByStatus: ArchiveHookFilterRule<Admin.Resources.Participation, "voted" | "not_voted">["fn"] = (data, value) => {
    return data?.filter(participation => value === "voted" ? participation.votes.length : !participation.votes.length)
}

const filterByPayment: ArchiveHookFilterRule<Admin.Resources.Participation, "paid" | "not_paid">["fn"] = (data, value) => {
    return data?.filter(participation => participation.paid === (value === "paid"))
}

// TYPES
interface Props {
    sections: Interfaces.Section[]
    archive: ArchiveHookResponse<Admin.Resources.Participation>
}